(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[76329],{

/***/ 23548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Title = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "text-xl font-bold text-orange",
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 42544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Pages_Detail; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/ImageLoader.js
var ImageLoader = __webpack_require__(71700);
// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
// EXTERNAL MODULE: ./components/Detail/Photos.module.css
var Photos_module = __webpack_require__(98627);
var Photos_module_default = /*#__PURE__*/__webpack_require__.n(Photos_module);
;// CONCATENATED MODULE: ./components/Detail/Photos.js




var Loading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Photos_module_default()).Photos,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-full relative"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-full relative"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-full relative"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-full relative"
            })
        ]
    });
};
var Content = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 91794).then(__webpack_require__.bind(__webpack_require__, 91794));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91794)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {});
    }
});
var Photos = function(param) {
    var data = param.data, page = param.page;
    var Images = data;
    if (Images.length !== 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
        Images: Images,
        page: page,
        styles: (Photos_module_default())
    });
    else return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {});
};
/* harmony default export */ var Detail_Photos = (Photos);

// EXTERNAL MODULE: ./node_modules/react-date-range/dist/styles.css
var styles = __webpack_require__(71541);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/theme/default.css
var theme_default = __webpack_require__(32049);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./context/context.js
var context = __webpack_require__(94268);
// EXTERNAL MODULE: ./node_modules/is-mobile/index.js
var is_mobile = __webpack_require__(63805);
var is_mobile_default = /*#__PURE__*/__webpack_require__.n(is_mobile);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
// EXTERNAL MODULE: ./components/Detail/Title.js
var Title = __webpack_require__(23548);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./validations/ReservationsLoginShema.js
var ReservationsLoginShema = __webpack_require__(88041);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./icons/icons.js
var icons = __webpack_require__(17601);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/yup-locales/dist/yup-locales.esm.js
var yup_locales_esm = __webpack_require__(18700);
;// CONCATENATED MODULE: ./validations/GavelLoginSheme.js


if (true) es/* setLocale */.i_(yup_locales_esm.tr); // en: Yup varsayilan (Ingilizce) mesajlari
var GavelLoginSheme = es/* object */.Ry().shape({
    reservationNumber: es/* number */.Rx().required()
});

;// CONCATENATED MODULE: ./components/GavelLoginForm.js










var GavelLoginForm = function(param) {
    var setGavelLoginSuccess = param.setGavelLoginSuccess, emlak = param.emlak;
    var ref = (0,TranslationContext/* useTranslation */.m)(), loginRightDescription = ref.loginRightDescription, loginRightDescriptionContactLink = ref.loginRightDescriptionContactLink, loginLeftSubtitle = ref.loginLeftSubtitle, loginLeftTitle = ref.loginLeftTitle, loginLeftCopyRight = ref.loginLeftCopyRight, welcome = ref.welcome, loginSuccess = ref.loginSuccess, loginFormEmail = ref.loginFormEmail, loginReservationNumber = ref.loginReservationNumber, login = ref.login, loginRightDescriptionBottom = ref.loginRightDescriptionBottom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "lg:mt-1 m-auto max-w-screen-sm p-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mt-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                    children: "Rezervasyon Giri\u015Fi"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                    initialValues: {
                        reservationNumber: ""
                    },
                    validationSchema: GavelLoginSheme,
                    onSubmit: function(values, actions) {
                        (0,api/* GavelLogin */.Ld)(values.reservationNumber, emlak).then(function(response) {
                            if (response.data.success) {
                                setGavelLoginSuccess(1);
                                react_toastify_esm/* toast.success */.Am.success(loginSuccess);
                            } else {
                                react_toastify_esm/* toast.error */.Am.error(response.data.error);
                            }
                        }).catch(function(error) {
                            react_toastify_esm/* toast.error */.Am.error(error.message);
                        }).finally(function() {
                            actions.setSubmitting(false);
                        });
                    },
                    children: function(props) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: "mb-[54px] w-full mt-3",
                            onSubmit: props.handleSubmit,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative z-0 mb-[13px] w-full group",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: "reservationNumber",
                                            className: "block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer",
                                            placeholder: " ",
                                            onChange: props.handleChange,
                                            value: props.values.reservationNumber
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "reservationNumber",
                                            className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                                            children: loginReservationNumber
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm mb-3 text-red-600",
                                    children: "(Rezervasyon \u0130\u015Flemlerinde kulland\u0131\u011F\u0131n\u0131z mail adresinizden ula\u015Fabilirsiniz.)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    disabled: props.isSubmitting || !props.isValid || !props.dirty,
                                    type: "submit",
                                    className: "text-white md:px-[2.75rem] px-8 md:py-[1.188rem] py-3 duration-200 bg-product-type-color hover:opacity-90 focus:ring-4 font-medium rounded-lg text-sm text-center disabled:opacity-60 disabled:cursor-not-allowed",
                                    children: login
                                })
                            ]
                        });
                    }
                })
            ]
        })
    });
};
//d
/* harmony default export */ var components_GavelLoginForm = (GavelLoginForm);

// EXTERNAL MODULE: ./components/Pages/ProductCategory.js + 9 modules
var ProductCategory = __webpack_require__(1237);
;// CONCATENATED MODULE: ./components/Pages/Detail.js







 // main css file
 // theme css file






var ProductInfo = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 68291).then(__webpack_require__.bind(__webpack_require__, 68291));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68291)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full flex flex-col items-center justify-center py-4 lg:hidden",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    containerClassName: "w-1/2",
                    className: "h-7"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    containerClassName: "w-1/4 mt-1",
                    className: "h-4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    containerClassName: "w-1/4 mt-2",
                    className: "h-6"
                })
            ]
        });
    }
});
var SidebarForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(60035), __webpack_require__.e(58355), __webpack_require__.e(58073), __webpack_require__.e(98555), __webpack_require__.e(10316)]).then(__webpack_require__.bind(__webpack_require__, 19161));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19161)
            ];
        }
    },
    ssr: false
});
var AvailabilityModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(60035), __webpack_require__.e(58355), __webpack_require__.e(98555), __webpack_require__.e(8121)]).then(__webpack_require__.bind(__webpack_require__, 39718));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39718)
            ];
        }
    },
    ssr: false
});
var Right = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 31266).then(__webpack_require__.bind(__webpack_require__, 31266));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31266)
            ];
        }
    }
});
var ListVilla = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 43440).then(__webpack_require__.bind(__webpack_require__, 43440));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43440)
            ];
        }
    },
    ssr: false
});
var WriteReview = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(60035), __webpack_require__.e(32068)]).then(__webpack_require__.bind(__webpack_require__, 32068));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32068)
            ];
        }
    },
    ssr: false
});
var Detail = function(param) {
    var ssr = param.ssr, isAppWebView = param.isAppWebView, deviceType = param.deviceType;
    var ref;
    var detailSimilarVillasTitle = (0,TranslationContext/* useTranslation */.m)().detailSimilarVillasTitle;
    var isPhone = is_mobile_default()();
    var ref1 = (0,react.useContext)(context/* StoreContext */.x), backdrop = ref1.backdrop, mobileBar = ref1.mobileBar, setMobileBar = ref1.setMobileBar, sonDakikaDates = ref1.sonDakikaDates, setSonDakikaDates = ref1.setSonDakikaDates;
    var ref2 = (0,react.useState)(false), showAvailability = ref2[0], setShowAvailability = ref2[1];
    var ref3 = (0,react.useState)(false), gavelLoginSuccess = ref3[0], setGavelLoginSuccess = ref3[1];
    //Son dakika fırsatındaki tarihleri rezervasyon formuna aktarır
    var SelectSonDakika = function(start, end) {
        if (!start || !end) {
            setSonDakikaDates(null);
            return;
        }
        setSonDakikaDates([
            {
                startDate: new Date(start + "T00:00:00"),
                endDate: new Date(end + "T00:00:00"),
                key: "selection",
                isShow: 0
            }, 
        ]);
        // Mobil / uygulama: alttaki "Rezervasyon Yap" formuyla aynı paneli aç
        if (isPhone || isAppWebView) setMobileBar("reservationForm");
    };
    (0,react.useEffect)(function() {
        if (backdrop == false) setShowAvailability(false);
    }, [
        backdrop
    ]);
    (0,react.useEffect)(function() {
        setGavelLoginSuccess(false);
        setSonDakikaDates(null);
        if ((0,ProductCategory.getCookie)("user-link") == "1") {
            var ref;
            if (("," + (0,ProductCategory.getCookie)("ids") + ",").indexOf("," + ((ref = ssr.result) === null || ref === void 0 ? void 0 : ref.id) + ",") > -1) {
                setGavelLoginSuccess(true);
                ssr.result.gavel = 0;
            }
        }
    }, [
        (ref = ssr.result) === null || ref === void 0 ? void 0 : ref.id
    ]);
    (0,react.useEffect)(function() {
        setShowAvailability(mobileBar == "availabilityMobile");
    }, [
        mobileBar
    ]);
    if (ssr.result.gavel == "1" && !gavelLoginSuccess && ssr.result.gavelDetailOption == "1") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GavelLoginForm, {
            setGavelLoginSuccess: setGavelLoginSuccess,
            emlak: ssr.result.id
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lg:mt-1 bg-[#ECF2F4] lg:bg-white",
        children: [
            showAvailability ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailabilityModal, {
                showAvailability: showAvailability,
                setShowAvailability: setShowAvailability,
                id: ssr.result.id,
                baslik: ssr.result.baslik,
                kisi: ssr.result.kisi,
                isActive: ssr.result.aktif,
                gavel: ssr.result.gavel,
                start2: ssr.result.start2,
                isAppWebView: isAppWebView,
                deviceType: deviceType,
                paymentType: ssr.result.paymentType,
                defaultDates: sonDakikaDates
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfo, {
                data: ssr.result.photos,
                title: ssr.result.baslik,
                destination: ssr.result.destination,
                video: ssr.result.video,
                page: ssr.result,
                isAppWebView: isAppWebView
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail_Photos, {
                data: ssr.result.photos,
                page: ssr.result
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative lg:-mt-36 w-full z-10",
                children: [
                    !isPhone && /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarForm, {
                        showAvailability: showAvailability,
                        setShowAvailability: setShowAvailability,
                        page: ssr.result,
                        isAppWebView: isAppWebView,
                        deviceType: deviceType,
                        defaultState: sonDakikaDates
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Right, {
                        showAvailability: showAvailability,
                        setShowAvailability: setShowAvailability,
                        page: ssr.result,
                        isPhone: isPhone,
                        deviceType: deviceType,
                        onSelectSonDakika: SelectSonDakika
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListVilla, {
                baslik: detailSimilarVillasTitle,
                className: "bg-brand-gray-7 lg:bg-transparent",
                ItemClassName: "bg-white lg:bg-brand-gray-7 ",
                fetch: (0,api/* GetSimilarVillas */.Nj)(ssr.result.id, ssr.result.emlak_bolgesi),
                IconUrl: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/icons/trophy.svg",
                    alt: "trophy",
                    width: 39,
                    height: 29,
                    loader: ImageLoader/* default */.Z
                })
            }),
            ssr.result.ReviewReservation && /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteReview, {
                ssr: ssr.result
            })
        ]
    });
};
/* harmony default export */ var Pages_Detail = (Detail);


/***/ }),

/***/ 88041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ReservationLoginShema; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);
/* harmony import */ var yup_locales__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18700);


if (true) yup__WEBPACK_IMPORTED_MODULE_0__/* .setLocale */ .i_(yup_locales__WEBPACK_IMPORTED_MODULE_1__.tr); // en: Yup varsayilan (Ingilizce) mesajlari
var ReservationLoginShema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required().email(),
    reservationNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().required()
});


/***/ }),

/***/ 98627:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Photos":"Photos_Photos__BXhg3"};

/***/ })

}]);